module.exports = {"attributes":{"width":"8","height":"7","viewBox":"0 0 8 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M6.69622 0.469705C6.98916 0.176971 7.46396 0.176884 7.75677 0.469705C8.0495 0.762635 8.04957 1.23744 7.75677 1.53025L3.3095 5.97459C3.01665 6.26724 2.54181 6.26724 2.24896 5.97459L0.469659 4.19724C0.176686 3.90445 0.176875 3.42968 0.469659 3.1367C0.762405 2.84377 1.23721 2.84308 1.53021 3.13572L2.77923 4.38377L6.69622 0.469705Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
